import { UIKit } from "@/shared/ui";
/**
 * Плашка над холстом во время черчения. Два тона:
 *   • error — почему стену здесь поставить нельзя (пересекла бы другую или легла бы на неё);
 *   • info  — что делать дальше (например, откуда начать кабель).
 * Висит сверху по центру холста, а не у курсора — как обычное уведомление, чтобы
 * не мешать вести линию, и ниже панели инструментов сверху (`overlayTopOffset`). По центру
 * видимой части: левые панели (`inset`) её не закрывают.
 * HTML поверх SVG, как и поле ввода длины, — чтобы текст не зависел от зума.
 */
import { useEditorStore } from "@/widgets/editor";

interface Props {
	text: string;
	tone?: "error" | "info";
	/** Сколько холста слева закрыто панелями, px */
	inset?: number;
}

export const DrawHint = ({ text, tone = "error", inset = 0 }: Props) => {
	const top = useEditorStore((s) => s.overlayTopOffset);
	const phone = window.matchMedia("(max-width: 767px)").matches;
	const colors =
		tone === "error" ? "border-danger text-danger" : "border-[#cfe0fd] text-[#1f4fb8] bg-[#f5f8ff]";
	return (
		<div
			role="status"
			className={`pointer-events-none absolute z-5 flex -translate-x-1/2 items-center gap-2 rounded-lg border bg-surface px-3 py-1.5 text-sm whitespace-nowrap shadow-lg ${colors}`}
			// На телефоне панели открываются окном поверх, и сдвигать плашку не нужно;
			// отступ сверху учитывает полосу переключения этапов 2D-плана
			style={{ top: top + 52, left: `calc(50% + ${phone ? 0 : inset / 2}px)` }}
		>
			<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
				<circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5" />
				<path d="M8 4.5v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
				<circle cx="8" cy="11.2" r="0.9" fill="currentColor" />
			</svg>
			<UIKit.Text as="span">{text}</UIKit.Text>
		</div>
	);
};
